import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

export interface LessonProgress {
  lessonId: number;
  wpm: number;
  accuracy: number;
  errors: number;
  completedAt: Date;
}

@Injectable({
  providedIn: 'root'
})
export class ProgressService {
  constructor(private storage: Storage) {
    this.initializeStorage();
  }

  private async initializeStorage() {
    await this.storage.create();
  }

  async saveLessonProgress(progress: LessonProgress) {
    const key = `lesson_${progress.lessonId}`;
    const existingProgress = await this.storage.get(key) || [];
    existingProgress.push(progress);
    await this.storage.set(key, existingProgress);
  }

  async getLessonProgress(lessonId: number): Promise<LessonProgress[]> {
    const key = `lesson_${lessonId}`;
    return await this.storage.get(key) || [];
  }

  async getBestProgress(lessonId: number): Promise<LessonProgress | null> {
    const progress = await this.getLessonProgress(lessonId);
    if (!progress.length) return null;
    
    return progress.reduce((best: LessonProgress | null, current: LessonProgress) => {
      if (!best) return current;
      if (current.wpm > best.wpm && current.accuracy >= best.accuracy) return current;
      return best;
    }, null as LessonProgress | null);
  }

  async clearProgress() {
    const keys = await this.storage.keys();
    for (const key of keys) {
      if (key.startsWith('lesson_')) {
        await this.storage.remove(key);
      }
    }
  }
} 